<template>
  <nav
    class="layout-footer footer"
    :class="getLayoutFooterBg()"
  >
    <div class="container-fluid container-p-x pb-3">
      <a
        href="#"
        class="footer-link pt-3"
      >
        &#169;&nbsp;2024&nbsp;-&nbsp;Croix-Rouge de Belgique - Frontend 2.7.0 - Api 3.3.0
      </a>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'AppLayoutFooter',

  methods: {
    getLayoutFooterBg() {
      return `bg-${this.layoutFooterBg}`;
    },
  },
};
</script>
